import React, { useEffect, useState } from 'react';
import { useSetting } from '../../../util/useSetting';
import PreviousSvg from '../../../svg/student/Previous.js';
import NextSvg from '../../../svg/student/Next.js';
import ReloadSvg from '../../../svg/student/Reload.js';
import { connect } from 'react-redux';
import SliderPage from './SliderPage';
import Instruction from '../Instruction';
import SettingPopup from './SettingPopup.js';
import { useNavigate } from 'react-router-dom';


function Task(props) {
    const { fontSize } = useSetting();
    const [data, setData] = useState(props.data)
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [unLockedIndex, setUnLockedIndex] = useState(0);
    const [showConfirmPopup, setShowConfirmPopup] = useState(false);
    const navigate = useNavigate();
    const handlePrevious = () => {
        let prevIndex = currentQuestionIndex - 1;
        if (prevIndex >= 0) {
            setCurrentQuestionIndex(prevIndex);
        }
    }
    const handleNext = () => {
        let nextIndex = currentQuestionIndex + 1;
        // if(data?.questions[currentQuestionIndex].type === '選擇題' && !data.questions[currentQuestionIndex].options.some(row=>row?.selected)){
        //     alert('請先回答選擇題');
        //     return
        // }else if(data?.questions[currentQuestionIndex].type === '表格問題' && data.questions[currentQuestionIndex].table.some(row=>(!row?.answer1)&&(!row?.answer2))){
        //     alert('請先完成表格問題');
        //     return
        // }
        if (nextIndex < data.questions.length) {
            setCurrentQuestionIndex(nextIndex);
            if (nextIndex > unLockedIndex) {
                setUnLockedIndex(nextIndex);
            }
        } else {
            setShowConfirmPopup(true);
        }
    }
    const [unlockedTabs, setUnlockedTabs] = useState([0]);
    useEffect(() => {
        if (data?.questions?.[currentQuestionIndex].type === 'display-text') {
            let i = 0;
            for (let j = 0; j <= currentQuestionIndex; j++) {
                let q = data?.questions?.[j];
                if (q.type === 'display-text' && j < currentQuestionIndex) {
                    i++;
                }
            }
            if (unlockedTabs.includes(i)) {
                return
            } else {
                setUnlockedTabs([...unlockedTabs, i]);
                setTab(i);
            }
        }
    }, [currentQuestionIndex]);

    const [tab, setTab] = useState(0);

    const [showInstructions, setShowInstructions] = useState(false);
    const [isSettingMenuVisible, setIsSettingMenuVisible] = useState(false);
    const [startTime, setStartTime] = useState(props.startTime);
    const [timer, setTimer] = useState('00:00');//10 minutes
    useEffect(() => {
        function updateTimer() {
            const now = new Date().getTime();
            const elapsed = now - startTime;
            const remaining = Math.max(0, 30 * 60 * 1000 - elapsed); // 30 minutes in milliseconds
            const minutes = Math.floor(remaining / 60000);
            const seconds = Math.floor((remaining % 60000) / 1000);
            setTimer(`${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`);
        }

        const interval = setInterval(updateTimer, 1000);
        return () => clearInterval(interval);
    }, [startTime]);


    return (
        <div className='w-full flex flex-col h-full' style={{ fontSize }}>

            <div className='w-full flex flex-row justify-start gap-[8px] mt-[16px] px-[16px] font-[900]'>
                <button className='px-[18px] py-[4px] rounded-full flex flex-row items-center text-[white] gap-[8px] noto-san-hk font-[600]' style={{ background: 'linear-gradient(to right, #34778C, #63BBD1)' }} onClick={() => setIsSettingMenuVisible(!isSettingMenuVisible)}>
                    <img src='/secondary/setting.png' alt='設定' />
                    設定
                </button>
                <div className='flex flex-row gap-[8px]'>
                    {data?.questions?.map((question, index) => (
                        question.type === 'display-text' ? null :
                            <button className='w-[40px] h-[40px] rounded-[6px] flex items-center justify-center text-bold' style={{
                                background: currentQuestionIndex === index ? '#003A57' : currentQuestionIndex > index ? '#178E95' : 'linear-gradient(to bottom, #BEBEBE80, #F0FBFF)',
                                color: currentQuestionIndex === index ? 'white' : currentQuestionIndex < index ? 'white' : 'black'
                            }} key={index}
                                onClick={() => {
                                    if (index > unLockedIndex) return;
                                    setCurrentQuestionIndex(index)
                                }}>{question?.id}</button>
                    ))}
                </div>
                 {props.startTime && <div className='flex flex-row gap-[8px]'>
                    <div className='flex items-center justify-center'>
                        <div className='text-white bg-[#003A57] py-[8px] px-[24px] rounded-[4px]' style={{ fontSize: fontSize }}>{timer}</div>
                    </div>
                </div>}
                <div className='flex flex-row gap-[8px] flex-1 justify-end'>
                    <button onClick={() => setShowInstructions(!showInstructions)}>
                        <img src='/secondary/btn1.png' />
                    </button>
                    <button onClick={handlePrevious}>
                        <img src='/secondary/btn2.png' />
                    </button>
                    <button onClick={handleNext}>
                        <img src='/secondary/btn3.png' />
                    </button>
                </div>
            </div>

            <div className='w-full flex flex-col items-center justify-center flex-1 overflow-auto noto-san-hk mt-[12px]'>

                {data?.questions[currentQuestionIndex]?.type === 'display-text' ? (
                    <div className='flex-1 flex flex-col w-full justify-center items-center'>
                        <div className='w-full text-white font-bold flex flex-col text-left px-[24px] py-[8px]' style={{ background: 'linear-gradient(to right, #55A8E0, #1C7595, #3B77A4)' }}>
                            {data?.name}<br />簡介
                        </div>
                        <div className='flex-1 w-full flex justify-center items-center'>
                            <div className='text-[#003A57] w-full max-w-[800px] text-left flex justify-center items-center' style={{ border: '1px solid #E3E3E3', padding: '64px' }}>
                                <div className='w-full max-w-[400px]' dangerouslySetInnerHTML={{ __html: data?.questions[currentQuestionIndex]?.html }} />
                            </div>
                        </div>
                    </div>
                ) : (
                    <SliderPage initalWidth={35}
                        leftComponent={<LeftComponent data={data} currentQuestionIndex={currentQuestionIndex} setData={setData} />}
                        rightComponent={<RightComponent unlockedTabs={unlockedTabs} data={data} currentQuestionIndex={currentQuestionIndex} setData={setData} tab={tab} setTab={setTab} />}
                    />
                )}
            </div>

            {showInstructions && (
                <Instruction close={() => setShowInstructions(false)} />
            )}
            {showConfirmPopup && <div className='absolute top-0 left-0 w-full h-full flex justify-center items-center bg-white bg-opacity-50 noto-san-hk font-bold' style={{ backdropFilter: 'blur(18px)' }}>
                <div className='bg-white p-[24px] rounded-[8px] flex flex-col items-center gap-[16px]' style={{ boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)', backgroundImage: 'url(/secondary/bg7.png)', backgroundSize: 'cover', backgroundPosition: 'center' }}>
                    <div className='text-[#6E0526] font-bold mb-[16px]'>小提示</div>
                    <div className='mb-[16px] text-center'>提交後將不能返回修改本部分答案，<br />是否繼續？</div>
                    <div className='flex flex-row gap-[16px]'>
                        <button className='px-[16px] py-[8px] text-black rounded-[4px] min-w-[200px] text-center rounded-full' style={{ background: 'linear-gradient(to bottom, #BEBEBE80, #FFFFFF)' }} onClick={() => setShowConfirmPopup(false)}>返回檢查</button>
                        <button className='px-[16px] py-[8px] bg-[#007A83] text-white rounded-[4px] min-w-[200px] text-center rounded-full' onClick={() => { props.onExit() }}>確認</button>
                    </div>
                </div>
            </div>}
            {isSettingMenuVisible && (
                <SettingPopup onClose={() => { navigate('/platform2/research-practices') }} onReturn={() => setIsSettingMenuVisible(false)} enableReturn={true} />
            )}

        </div>
    )
}


function LeftComponent(props) {
    const data = props.data;
    const { fontSize } = useSetting();

    const dragAndDropWidth = 160
    const dragAndDropHeight = 120
    const [dragSource, setdragSource] = useState(null)
    const [selectedDragOption, setselectedDragOption] = useState(null)
    useEffect(() => { setselectedDragOption(null) }, [props.currentQuestionIndex])

    const isDraggable = (optionIndex) => {
        for (let column of data?.questions[props.currentQuestionIndex]?.dragAndDrop) {
            for (let row of column?.rows) {
                if (row.studentAnswer === data?.questions[props.currentQuestionIndex]?.dragAndDropOptions?.[optionIndex]?.text) {
                    return false
                }
            }
        }
        return true
    }



    return <div className='flex flex-col w-full'>
        <div className='flex-1 flex flex-col w-full justify-center items-center'>
            <div className='w-full text-white font-bold flex flex-col text-left px-[24px] py-[8px]' style={{ background: 'linear-gradient(to right, #55A8E0, #1C7595, #3B77A4)' }}>
                {data?.name}<br />
                問題 {data?.questions?.[props.currentQuestionIndex]?.id}/{data?.questions?.filter(q => q.type !== 'display-text').length}
            </div>
        </div>
        {data?.questions[props.currentQuestionIndex]?.type === '選擇題' && (
            <div className='flex-1 w-full flex flex-col justify-start items-start p-[16px] gap-[16px]'>
                <div className='text-[#082037] font-[300]' style={{ fontSize: fontSize - 2 }}>{data?.questions[props.currentQuestionIndex]?.subtitle}</div>
                <div className='text-[#082037] font-[900]' style={{ fontSize: fontSize }}>{data?.questions[props.currentQuestionIndex]?.question}</div>
                <div className='w-full flex flex-col gap-[16px]'>
                    {data?.questions[props.currentQuestionIndex]?.options.map((option, oi) =>
                        <div key={oi} className='w-full text-[black] flex flex-row items-center gap-[16px] font-[400]'>
                            <button className='w-[20px] h-[20px] border border-[#005B8C] rounded-full flex-shrink-0' style={{ backgroundColor: option.selected ? '#005B8C' : 'transparent' }} onClick={
                                () => {
                                    let newData = { ...data }
                                    for (let op of data?.questions[props.currentQuestionIndex].options) {
                                        op.selected = false
                                    }
                                    newData.questions[props.currentQuestionIndex].options[oi].selected = true
                                    props.setData(newData)
                                }
                            }>

                            </button>
                            {option.text}
                        </div>
                    )}
                </div>
            </div>
        )}
        {['表格問題'].includes(data?.questions[props.currentQuestionIndex]?.type) && (
            <div className='w-full flex flex-col gap-[8px] rounded-[7px] mt-[24px] px-[24px]'>
                <div className='text-[#082037] font-[300]' style={{ fontSize: fontSize - 2 }}>{data?.questions[props.currentQuestionIndex]?.subtitle}</div>
                <div className='text-[#082037] font-[900]' style={{ fontSize: fontSize }}>{data?.questions[props.currentQuestionIndex]?.question}</div>
                <div className='flex flex-col w-full mt-[16px]'>
                    <div className='flex flex-row items-stretch w-full border-black font-[700]'>
                        <div className='bg-[#EDF5F8] text-black flex-1 border-[#9CB8D3] border-[1px] w-full px-[12px] py-[4px] flex items-center justify-center'>
                            {data.questions[props.currentQuestionIndex]?.header?.[0] || ''}
                        </div>
                        <div className='bg-[#EDF5F8] text-black border-[#9CB8D3] border-[1px] px-[12px] py-[4px] text-center flex items-center justify-center' style={{ width: 100 }}>
                            {data.questions[props.currentQuestionIndex]?.header?.[1] || ''}
                        </div>
                        <div className='bg-[#EDF5F8] text-black border-[#9CB8D3] border-[1px] px-[12px] py-[4px]  text-center flex items-center justify-center' style={{ width: 100 }}>
                            {data.questions[props.currentQuestionIndex]?.header?.[2] || ''}
                        </div>
                    </div>
                    {data?.questions[props.currentQuestionIndex]?.table?.map((row, rowIndex) => (
                        <div key={rowIndex} className='flex flex-row items-stretch'>
                            <div className='flex-1 border-[#9CB8D3] border-x-[1px] border-y-[1px] px-[12px] py-[4px]'>{row.text}</div>
                            <div className='border-[#9CB8D3] border-[1px] px-[12px] py-[4px] flex flex-row justify-center items-center' style={{ width: 100 }}>
                                <div>
                                    <div className='flex bg-[#ddd] rounded-full p-[1px]'>
                                        <button
                                            className={`w-[20px] h-[20px] rounded-full border-[5px] border-[#fafafa] ${row.answer1 ? 'bg-blue-500' : 'bg-[#fafafa]'}`}
                                            onClick={() => {
                                                let data_ = { ...data }
                                                if (data_.questions[props.currentQuestionIndex]?.data?.multipleChoiceType !== '多項選擇題') {
                                                    data_.questions[props.currentQuestionIndex].table[rowIndex].answer1 = true
                                                    data_.questions[props.currentQuestionIndex].table[rowIndex].answer2 = false
                                                } else
                                                    data_.questions[props.currentQuestionIndex].table[rowIndex].answer1 = !data_.questions[props.currentQuestionIndex].table[rowIndex].answer1
                                                props.setData(data_)
                                            }}
                                        ></button>
                                    </div>
                                </div>
                            </div>
                            <div className=' border-[#9CB8D3] border-[1px] px-[12px] py-[4px] flex flex-row justify-center justify-center items-center' style={{ width: 100 }}>
                                <div>
                                    <div className='flex bg-[#ddd] rounded-full p-[1px]'>
                                        <button
                                            className={`w-[20px] h-[20px] rounded-full border-[5px] border-[#fafafa] ${row.answer2 ? 'bg-blue-500' : 'bg-[#fafafa]'}`}
                                            onClick={() => {
                                                let data_ = { ...data }
                                                if (data_.questions[props.currentQuestionIndex]?.data?.multipleChoiceType !== '多項選擇題') {
                                                    data_.questions[props.currentQuestionIndex].table[rowIndex].answer2 = true
                                                    data_.questions[props.currentQuestionIndex].table[rowIndex].answer1 = false
                                                } else
                                                    data_.questions[props.currentQuestionIndex].table[rowIndex].answer2 = !data_.questions[props.currentQuestionIndex].table[rowIndex].answer2
                                                props.setData(data_)
                                            }}
                                        ></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}

                </div>
            </div>
        )}
        {/*end of form table question*/}

        {['填寫問題'].includes(data?.questions[props.currentQuestionIndex]?.type) && (
            <div className='w-full flex flex-col gap-[8px] rounded-[7px] mt-[24px] px-[24px]'>
                <div className='text-[#082037] font-[300]' style={{ fontSize: fontSize - 2 }}>{data?.questions[props.currentQuestionIndex]?.subtitle}</div>
                <div className='flex flex-row items-center flex-wrap justify-start gap-[8px]'>
                    <div className='text-[#082037] font-[900]' style={{ fontSize: fontSize }}>{data?.questions[props.currentQuestionIndex]?.question_prefix}</div>
                    {data?.questions[props.currentQuestionIndex]?.isMultipleAnswer && data?.questions[props.currentQuestionIndex]?.question_prefix_ &&
                        <div className='text-[#082037] font-[900]' style={{ fontSize: fontSize - 2 }}>{data?.questions[props.currentQuestionIndex]?.question_prefix_}</div>
                    }
                    <input className='w-[100px] border-b border-black bg-[transparent]' />
                    {data?.questions[props.currentQuestionIndex]?.isMultipleAnswer && data?.questions[props.currentQuestionIndex]?.question_postfix_ &&
                        <div className='text-[#082037] font-[900]' style={{ fontSize: fontSize - 2 }}>{data?.questions[props.currentQuestionIndex]?.question_postfix_}</div>
                    }
                    {data?.questions[props.currentQuestionIndex]?.isMultipleAnswer && <input className='w-[100px] border-b border-black bg-[transparent]' />}
                    <div className='text-[#082037] font-[900]' style={{ fontSize: fontSize - 2 }}>{data?.questions[props.currentQuestionIndex]?.question_postfix}</div>
                </div>
            </div>)}

        {['短句作答題'].includes(data?.questions[props.currentQuestionIndex]?.type) && (
            <div className='w-full flex flex-col gap-[8px] rounded-[7px] mt-[24px] px-[24px]'>
                <div className='text-[#082037] font-[300]' style={{ fontSize: fontSize - 2 }}>{data?.questions[props.currentQuestionIndex]?.subtitle}</div>
                <div className='flex flex-row items-center flex-wrap justify-start gap-[8px]'>
                    <div className='text-[#082037] font-[900]' style={{ fontSize: fontSize }}>{data?.questions[props.currentQuestionIndex]?.question}</div>
                    <textarea className='w-full border-[1px] rounded-[4px] border-black bg-[white] min-h-[100px] mt-[16px] p-[4px]' />
                </div>
            </div>
        )}

        {['拖放式問題'].includes(data?.questions[props.currentQuestionIndex]?.type) && (
            <div className='w-full flex flex-col bg-[#F8F8F8] gap-[8px] rounded-[7px]' style={{ padding: 16 }}>
                <div className='text-[#082037] font-[300]' style={{ fontSize: fontSize - 2 }}>{data?.questions[props.currentQuestionIndex]?.subtitle}</div>
                <div className='flex flex-row items-center flex-wrap justify-start gap-[8px]'>
                    <div className='text-[#082037] font-[900]' style={{ fontSize: fontSize }}>{data?.questions[props.currentQuestionIndex]?.question}</div>
                </div>
                <div className='w-full flex flex-row justify-start items-stretch overflow-auto'>
                    {data?.questions[props.currentQuestionIndex]?.dragAndDrop?.map((column, columnIndex) =>
                        <div key={columnIndex} className='bg-[rgb(210,210,210)] p-[2px] min-w-[100px] form-input flex flex-col flex-1'>
                            <div className='flex flex-col flex-[1] w-full gap-[4px]'>
                                <div className='bg-[rgb(230,238,247)] text-black w-full font-[700] px-[12px] py-[4px]'>
                                    {column?.title || ''}
                                </div>

                                {column?.rows?.map((row, rowIndex) =>
                                    <div key={rowIndex} className='p-[2px] relative w-full' style={{ fontSize: fontSize - 4 }}>
                                        {row?.type === '拖放格' && <div className='relative cursor-pointer bg-white flex flex-col items-center justify-center p-[4px]'
                                            onDragOver={(e) => { e.preventDefault(); }}
                                            onDrop={(e) => {
                                                if (dragSource !== null) {
                                                    setselectedDragOption(null)
                                                    let data_ = { ...data }
                                                    data.questions[props.currentQuestionIndex].dragAndDrop[columnIndex].rows[rowIndex].studentAnswer = data_.questions[props.currentQuestionIndex].dragAndDropOptions[dragSource].text
                                                    props.setData(data_)
                                                    setdragSource(null)
                                                }
                                            }}
                                            onClick={() => {
                                                if (selectedDragOption !== null) {
                                                    let data_ = { ...data }
                                                    data.questions[props.currentQuestionIndex].dragAndDrop[columnIndex].rows[rowIndex].studentAnswer = data_.questions[props.currentQuestionIndex].dragAndDropOptions[selectedDragOption].text
                                                    props.setData(data_)
                                                    setselectedDragOption(null)
                                                    setdragSource(null)
                                                }
                                            }}
                                            style={{ width: '100%', height: (dragAndDropHeight) * (row.size || 1), border: row?.studentAnswer ? '1px solid black' : 'none' }}>
                                            {/* <DropDownMenu value={row.answer||'--- 無 ---'} options={['--- 無 ---',...(item?.data?.dragAndDropOptions||[]).map((o)=>o.text)]} select={
                                                                        (type)=>{if(props.onEditKey)props.onEditKey(item,index,'dragAndDrop',[...item.data?.dragAndDrop.slice(0,columnIndex),{...column,rows:[...column?.rows.slice(0,rowIndex),{...row,answer:type},...column?.rows.slice(rowIndex+1)]},...item.data?.dragAndDrop.slice(columnIndex+1)])}
                                                                    }/> */}
                                            {row?.studentAnswer || ''}
                                            {row?.studentAnswer && <div className='absolute top-[2px] right-[2px] cursor-pointer' onClick={() => {
                                                let data_ = { ...data }
                                                data_.questions[props.currentQuestionIndex].dragAndDrop[columnIndex].rows[rowIndex].studentAnswer = null
                                                props.setData(data_)
                                            }}>
                                                <div className='font-bold'>X</div>
                                            </div>}
                                        </div>}
                                        {row?.type === '文字' && <div className='bg-white flex flex-col' style={{ width: '100%', height: (dragAndDropHeight) * (row.size || 1) }}>
                                            <div className='px-[16px] w-full py-[6px] rounded-[7px] w-full h-full flex items-center justify-center' >
                                                <div dangerouslySetInnerHTML={{ __html: row?.text || '' }} />
                                            </div>
                                        </div>}
                                        {row?.type === '空白區域' && <div className='flex flex-col' style={{ width: '100%', height: (dragAndDropHeight) * (row.size || 1) }}>

                                        </div>}

                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>

                <div className='flex flex-row w-full gap-[2%] flex-wrap' style={{ fontSize: fontSize - 4 }}>
                    {data?.questions[props.currentQuestionIndex]?.dragAndDropOptions?.map((option, optionIndex) => (
                        <div className='flex flex-row items-center cursor-pointer bg-[white] rounded-[2px] select-none w-[32%] mb-[8px]'
                            draggable={isDraggable(optionIndex)} key={optionIndex}
                            onDragStart={(e) => { setdragSource(optionIndex) }}
                            onDragEnd={(e) => { setdragSource(null) }}
                            onDragOver={(e) => { e.preventDefault(); }}
                            onClick={() => {
                                if (isDraggable(optionIndex))
                                    setselectedDragOption(optionIndex === selectedDragOption ? null : optionIndex)
                            }}
                            // onTouchStart={(e)=>{setdragSource(optionIndex)}}
                            // onTouchEnd={(e)=>{setdragSource(null)}}
                            style={{ aspectRatio: 4 / 3, opacity: isDraggable(optionIndex) ? 1 : .3, border: optionIndex === selectedDragOption ? '2px solid blue' : '1px solid black', boxShadow: dragSource === optionIndex ? '0px 0px 2px 2px green' : '0px 0px 1px 1px #00000080' }}>

                            <div className=' px-[12px] py-[4px]'>
                                {option.text}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        )}

        {['表格問題2'].includes(data?.questions[props.currentQuestionIndex]?.type) && (
            <div className='w-full flex flex-col bg-[#F8F8F8] gap-[8px] rounded-[7px]' style={{ padding: 16 }}>
                <div className='text-[#082037] font-[300]' style={{ fontSize: fontSize - 2 }}>{data?.questions[props.currentQuestionIndex]?.subtitle}</div>
                <div className='flex flex-row items-center flex-wrap justify-start gap-[8px]'>
                    <div className='text-[#082037] font-[900]' style={{ fontSize: fontSize }}>{data?.questions[props.currentQuestionIndex]?.question}</div>
                </div>
                <div className='w-full flex flex-row justify-start items-stretch overflow-auto'>
                    {data?.questions[props.currentQuestionIndex]?.table?.map((column, columnIndex) =>
                        <div key={columnIndex} className='bg-[rgb(210,210,210)] p-[2px] min-w-[100px] form-input flex flex-col' style={{ flex: columnIndex === 0 ? 1 : 2 }}>
                            <div className='flex flex-col w-full gap-[2px]'>
                                <div className='bg-[rgb(230,238,247)] text-black w-full font-[700] px-[12px] py-[4px]'>
                                    {column?.title || ''} &nbsp;
                                </div>

                                {column?.rows?.map((row, rowIndex) =>
                                    <div key={rowIndex} className='p-[1px] relative w-full' style={{ fontSize: fontSize }}>

                                        <div className='bg-white flex flex-col' style={{ width: '100%', height: 80 }}>
                                            <div className='px-[16px] w-full py-[6px] rounded-[7px] w-full h-full flex items-center justify-center gap-[8px]' >
                                                {columnIndex === 0 &&
                                                    <div className='flex bg-[#ddd] rounded-full p-[1px]'>
                                                        <button
                                                            className={`w-[20px] h-[20px] rounded-full border-[5px] border-[#fafafa] ${data.questions[props.currentQuestionIndex].answer === row ? 'bg-blue-500' : 'bg-[#fafafa]'}`}
                                                            onClick={() => {
                                                                let data_ = { ...data }
                                                                data_.questions[props.currentQuestionIndex].answer = row

                                                                props.setData(data_)
                                                            }}
                                                        ></button>
                                                    </div>
                                                }
                                                <div dangerouslySetInnerHTML={{ __html: row || '' }} />
                                            </div>
                                        </div>

                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        )}

    </div>;
}
function RightComponent(props) {
    const { fontSize } = useSetting();
    return <div className='flex flex-col w-full'>

        <div className='w-full flex flex-row justify-start gap-[8px] px-[16px] font-[900]'>
            {props.data?.tabs?.map((tab, ti) => (
                props.unlockedTabs.includes(ti) ?
                    <button
                        key={ti}
                        className='flex-1 max-w-[220px] overflow-hidden text-ellipsis whitespace-nowrap text-center py-[4px]'
                        style={props.tab === ti ? { background: 'linear-gradient(to left, #108B96, #003A57)', color: 'white', borderTopLeftRadius: '8px', borderTopRightRadius: '8px' } : { background: 'linear-gradient(to bottom, #ccc, #fff)', color: '#003A57', borderTopLeftRadius: '8px', borderTopRightRadius: '8px' }}
                        onClick={() => { props.setTab(ti) }}
                    >
                        {tab.name}
                    </button> : null
            ))}
        </div>
        <div className='w-full flex flex-row bg-[white] items-center' style={{ borderBottom: '1px solid #E3E3E3', marginTop: 4, gap: 6, padding: 6 }}>
            <div className='cursor-pointer'>
                <PreviousSvg height={30} width={30} />
            </div>
            <div className='cursor-pointer'>
                <NextSvg height={30} width={30} />
            </div>
            <div className='cursor-pointer'>
                <ReloadSvg height={30} width={30} />
            </div>
            <div className='flex-1'>
                <input disabled={true} className='w-full text-[black] bg-[#EEF2F6] rounded-[4px]' value={props.data?.tabs?.[props.tab]?.url ?? 'https://task.com'} style={{ fontSize: fontSize - 4, height: 40, paddingLeft: 24, paddingRight: 24 }} />
            </div>
        </div>
        <div className='w-full flex flex-col overflow-auto flex-1 gap-[16px] bg-white'>
            {props.tab !== undefined && props.data?.tabs?.[props.tab]?.contents?.map((content, ci) => (
                <div key={ci}>
                    {content.type === 'image'
                        ? <div className='px-[64px] w-full'>
                            <img src={content.src} alt='' className='w-full' />
                        </div>
                        : content.type === 'html'
                            ? <div className='px-[64px]' dangerouslySetInnerHTML={{ __html: content.html }} />
                            : content.type === 'title'
                                ? <div className='w-full px-[64px] text-center' style={{ fontSize: fontSize + 2, fontWeight: 'bold' }}>{content.text}</div>
                                : content.type === 'ai-comments'
                                    ? <AIComments content={content} />
                                    : null
                    }
                </div>
            ))}

        </div>
    </div>;
}

function AIComments(props) {
    const [isExpanded, setIsExpanded] = useState(false);
    const [isAiCommentGenerated, setIsAiCommentGenerated] = useState(false);
    return (
        <div className='px-[64px] py-[16px] w-full flex flex-col justify-start items-center'>
            <section className="ai-body ai-root comments-widget w-full " aria-labelledby="comments-toggle">
                <button id="comments-toggle" className="comments-toggle" type="button" aria-expanded={isExpanded} aria-controls="comments-panel" onClick={() => setIsExpanded(!isExpanded)}>
                    <span className="comments-toggle__label">
                        <span className="comment-icon" aria-hidden="true"></span>
                        讀者留言
                        <span class="comment-count">3</span>
                    </span>
                    <span className="toggle-action">
                        <span className="toggle-hint">展開</span>
                        <svg viewBox="0 0 20 20" aria-hidden="true"><path d="m5 7.5 5 5 5-5" /></svg>
                    </span>
                </button>

                {isExpanded && <div id="comments-panel" className="comments-panel">
                    <div className="comments-panel__inner">
                        <div className="comments-heading">
                            <h2>讀者留言</h2>
                            <div id="ai-control" className="ai-control">
                                <button id="ai-toggle" className="ai-button" type="button" aria-expanded="false" aria-pressed="false" aria-controls="ai-summary" title="滑鼠懸停預覽；點擊固定顯示" onClick={() => { setIsAiCommentGenerated(!isAiCommentGenerated) }}>
                                    <span aria-hidden="true">✦</span>【AI 總結】
                                </button>
                                {isAiCommentGenerated && <aside id="ai-summary" className="ai-summary" aria-hidden="true">
                                    <div className="ai-summary__label"><span aria-hidden="true">✦</span> AI 總結</div>
                                    <p>{props.content.comment_ai.comment}</p>
                                    <small>以下內容由 AI 根據留言自動生成。</small>
                                </aside>}
                            </div>
                        </div>

                        <div className="comment-list">
                            <article className="comment">
                                <div className="avatar avatar--james" aria-hidden="true"><span>{props.content.comment_1.name_abbr}</span></div>
                                <div><h3>{props.content.comment_1.name}</h3><p>{props.content.comment_1.comment}</p></div>
                            </article>
                            <article className="comment">
                                <div className="avatar avatar--sievers" aria-hidden="true"><span>{props.content.comment_2.name_abbr}</span></div>
                                <div><h3>{props.content.comment_2.name}</h3><p>{props.content.comment_2.comment}</p></div>
                            </article>
                            <article className="comment">
                                <div className="avatar avatar--stephen" aria-hidden="true"><span>{props.content.comment_3.name_abbr}</span></div>
                                <div><h3>{props.content.comment_3.name}</h3><p>{props.content.comment_3.comment}</p></div>
                            </article>
                        </div>
                    </div>
                </div>}
            </section>
        </div>
    )
}

export default connect((store) => {
    return {
        token: store.tokenReducer,
    }
})(Task)
